import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import config from '../config/config';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.defaultState = {
      uploads: [],
      uploadPreviews: [],
      stories: [],
      msg: {
        description: '',
        storyId: '',
        regionId: '',
        city: '',
        uik: '',
        ustatus: '',
        contacts: '',
        uploads: [],
      },
      errors: [],
    };
    this.state = this.defaultState;
    this.recaptchaInstance = null;
    this.fieldNames = {
      base: { name: 'Я не робот' },
      description: { name: 'Текст сообщения' },
      story_id: { name: 'Дата голосования' },
      region_id: { name: 'Регион' },
      ustatus: { name: 'Ваш статус' },
      contacts: { name: 'Контактная информация' },
    };
  }
  componentDidMount() {
    fetch('https://www.kartanarusheniy.org/settings')
      .then(res => {
        return res.json();
      })
      .then(json => {
        this.setState({ stories: json });
      });
  }
  componentWillReceiveProps(next) {
    this.setState({ msg: next.message });
  }
  handleChange = (name, value) => {
    this.setState(
      {
        msg: {
          ...this.state.msg,
          [name]: value,
        },
      },
      () => {}
    );
  };

  readAndPreview = (file, idx) => {
    // Make sure `file.name` matches our extensions criteria
    if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
      let reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          let { uploadPreviews } = this.state;
          uploadPreviews[idx] = reader.result;
          this.setState({
            uploadPreviews,
          });
        },
        false
      );
      reader.readAsDataURL(file);
    }
  };

  handleChangeUpload = e => {
    e.preventDefault();

    let { files } = e.target;
    // console.log("files", files)
    this.setState(
      { msg: { ...this.state.msg, uploads: files }, uploadPreviews: [] },
      () => {
        [].forEach.call(files, this.readAndPreview);
      }
    );

    // reader.onloadend = () => {
    //   console.log('handleChangeUpload', 'onloadend');
    //   Array.from(files).map((file, i) => {
    //     console.log(file, i);
    //   });
    //   // this.setState({
    //   //   file: file,
    //   //   imagePreviewUrl: reader.result,
    //   // });
    //   // reader.readAsDataURL(file);
    // };
  };

  verifyCallback = response => {
    this.setState({ recaptcha: response });
  };
  submitMsg = ev => {
    ev.preventDefault();
    const { msg } = this.state;

    let formData = new FormData();
    if (msg.uploads) {
      const fileList = msg.uploads;
      for (var x = 0; x < fileList.length; x++) {
        formData.append(
          `message[docs_attributes][${x}][asset]`,
          fileList.item(x)
        );
      }
    }
    formData.append('g-recaptcha-response', this.state.recaptcha);
    formData.append('message[description]', msg.description);
    formData.append('message[contacts]', msg.contacts);
    formData.append('message[region_id]', msg.regionId);
    formData.append('message[story_id]', msg.storyId);
    formData.append('message[ustatus]', msg.ustatus);

    fetch('https://www.kartanarusheniy.org/create_app', {
      method: 'POST',
      body: formData,
      // mode: 'no-cors',
    })
      .then(res => {
        return res.json();
      })
      .then(res => {
        // return res.json();
        console.log('res', res);
        if (res.errors) {
          this.setState({ errors: res.errors });
          this.recaptchaInstance.reset();
        }
      })
      .catch(err => {});
    // .then(data => {
    //   alert(JSON.stringify(data));
    // });
  };

  render() {
    const { msg, uploadPreviews, errors } = this.state;
    return (
      <div className="kn__b">
        <form onSubmit={ev => this.submitMsg(ev)}>
          <div className="kn__b--h1">Отправить сообщение о нарушении</div>
          <div className="kn__b--alert">
            Обязательно заполните поля, помеченные *
          </div>
          <div className="form-group">
            <label className="title" htmlFor="message_story_id">
              Дата голосования*
            </label>
            <select
              required
              className="form-control"
              name="message[story_id]"
              id="message_story_id"
              defaultValue="136"
              onChange={ev => this.handleChange('storyId', ev.target.value)}
            >
              {this.state.stories.map((item, i) => <option key={i} value="{item.id}">{item.end_date}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="title" htmlFor="message_story_id">
              Регион*
            </label>
            <select
              required
              className="form-control"
              name="message[region_id]"
              id="message_region_id"
              defaultValue=""
              onChange={ev => this.handleChange('regionId', ev.target.value)}
            >
              <option value="" />
              {config.regions.map((item, i) => (
                <option value={item.id} key={i}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="">Сообщение*</label>
            <div className="kn__msg-form--help">
              Подробно изложите факты: Ф. И. О. участников
              событий, адреса, даты, время, ссылки на источники.
            </div>
            <textarea
              required
              rows="10"
              className="form-control"
              name="message[description]"
              id="message_description"
              value={msg.description}
              onChange={ev => this.handleChange('description', ev.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="">Как с вами связаться?* (не публикуется)</label>
            <div className="kn__msg-form--help">Ваши фамилия, имя, отчество, телефон, электронная почта и другая контактная информация</div>
            <textarea
              rows="10"
              className="form-control"
              name="message[contacts]"
              id="message_contacts"
              value={msg.contacts}
              onChange={ev => this.handleChange('contacts', ev.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="">Ваш статус*</label>
            <select
              required
              className="form-control"
              name="message[ustatus]"
              id="message_ustatus"
              defaultValue=""
              onChange={ev => this.handleChange('ustatus', ev.target.value)}
            >
              <option value="" />
              {config.ustatuses.map((item, i) => (
                <option value={item.name} key={i}>
                  {item.name}
                </option>
              ))}
            </select>


          </div>
          <div className="form-group">
            <label className="title" htmlFor="message_upload">
              Добавить файл
            </label>
            <input
              type="file"
              multiple
              onChange={ev => this.handleChangeUpload(ev)}
            />
            <div className="uploads__list">
              {uploadPreviews.map((item, i) => (
                <div key={i}>
                  <div className="uploads__name">{msg.uploads[i].name}</div>
                  <img
                    style={styles.uploads.preview}
                    src={item}
                    alt={msg.uploads[i].name}
                  />
                </div>
              ))}
            </div>
            <div className="msg__recaptcha" style={styles.recapcha}>
              <div style={{ width: '304px', margin: '15px auto' }}>
                <Recaptcha
                  ref={e => (this.recaptchaInstance = e)}
                  sitekey="6LcBiigTAAAAAI9-MkDgz_Bvj4uiXQ-zB5RoEuW9" // PRODUCTION
                  // sitekey="6LddiSgTAAAAAI9NAktwvEWe5jkblFW0CVBqvDW5" // DEV
                  render="explicit"
                  hl="ru"
                  verifyCallback={this.verifyCallback}
                  // onloadCallback={callback}
                />
              </div>
            </div>
            {/*<div className="debug">{JSON.stringify(this.state)}</div>*/}
            <div style={styles.msgErrors}>
              {Object.keys(errors).map(key => (
                <div key={key}>
                  {this.fieldNames[key].name}: {errors[key].join(', ')}
                </div>
              ))}
            </div>
            <div style={styles.buttonSendWrap}>
              <button
                style={styles.buttonSend}
                onClick={ev => this.submitMsg(ev)}
              >
                Отправить
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const styles = {
  uploads: {
    preview: {
      maxWidth: '100px',
    },
  },
  recapcha: {
    margin: '30px',
  },
  buttonSendWrap: {
    textAlign: 'center',
    margin: '15px',
  },
  buttonSend: {
    color: '#fff',
    fontWeight: 'bold',
    backgroundColor: '#337ab7',
    borderColor: '#2e6da4',
    padding: '15px 30px',
    display: 'inline-block',
    cursor: 'pointer',
  },
  msgErrors: {
    color: 'red',
  },
};

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/Edit.js